<template>
  <v-row>
    <v-col class="py-0">
      <v-expansion-panel-content>
        <v-row>
          <v-col
            cols="6"
            sm="4"
            md="2"
          >
            <v-text-field
              v-model="screen.order"
              label="Порядковый номер экрана"
              type="number"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.background"
              label="Цвет фона"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.toolbar"
              label="Цвет тулбара"
            />
          </v-col>
        </v-row>
        <!-- Logo Card -->
        <v-row>
          <v-col
            cols="12"
            class="deep-purple--text text--lighten-1"
          >
            Текст над лого Оплатой картой
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.textAboveLogoCard.size"
              label="Размер шрифта"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.textAboveLogoCard.color"
              label="Цвет шрифта"
            />
          </v-col>
          <v-col
            cols="12"
            md="12"
          >
            <v-textarea
              v-model="screen.textAboveLogoCard.text"
              label="Текст над лого Оплатой картой"
              type="text"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="3"
          >
            <uploadFiles
              v-model="screen.logoCardFile"
              label="Логотип для вида оплаты картой"
              :btn_text="'Загрузить фотографию'"
              :limit="1"
              :single="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-text-field
              v-model="screen.logoCardData.width"
              label="Ширина изображения"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-text-field
              v-model="screen.logoCardData.height"
              label="Высота изображения"
              type="number"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col
            cols="12"
            class="cyan--text text--lighten-1"
          >
            Текст под лого Оплатой картой
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.textBelowLogoCard.size"
              label="Размер шрифта"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.textBelowLogoCard.color"
              label="Цвет шрифта"
            />
          </v-col>
          <v-col
            cols="12"
            md="12"
          >
            <v-textarea
              v-model="screen.textBelowLogoCard.text"
              label="Текст под лого Оплатой картой"
              type="text"
            />
          </v-col>
        </v-row>
        <!-- end Logo card -->

        <!-- Logo Cash -->
        <v-row>
          <v-col
            cols="12"
            class="deep-purple--text text--lighten-1"
          >
            Текст над лого Оплатой наличными
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.textAboveLogoCash.size"
              label="Размер шрифта"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.textAboveLogoCash.color"
              label="Цвет шрифта"
            />
          </v-col>
          <v-col
            cols="12"
            md="12"
          >
            <v-textarea
              v-model="screen.textAboveLogoCash.text"
              label="Текст над лого Оплатой наличными"
              type="text"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="3"
          >
            <uploadFiles
              v-model="screen.logoCashFile"
              label="Логотип для вида оплаты наличными"
              :btn_text="'Загрузить фотографию'"
              :limit="1"
              :single="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-text-field
              v-model="screen.logoCashData.width"
              label="Ширина изображения"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-text-field
              v-model="screen.logoCashData.height"
              label="Высота изображения"
              type="number"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col
            cols="12"
            class="cyan--text text--lighten-1"
          >
            Текст под лого Оплатой наличными
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.textBelowLogoCash.size"
              label="Размер шрифта"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.textBelowLogoCash.color"
              label="Цвет шрифта"
            />
          </v-col>
          <v-col
            cols="12"
            md="12"
          >
            <v-textarea
              v-model="screen.textBelowLogoCash.text"
              label="Текст под лого Оплатой наличными"
              type="text"
            />
          </v-col>
        </v-row>
        <!-- end Logo cash -->

        <!-- Logo QR -->
        <v-row>
          <v-col
            cols="12"
            class="deep-purple--text text--lighten-1"
          >
            Текст над лого Оплатой QR кодом
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.textAboveLogoQr.size"
              label="Размер шрифта"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.textAboveLogoQr.color"
              label="Цвет шрифта"
            />
          </v-col>
          <v-col
            cols="12"
            md="12"
          >
            <v-textarea
              v-model="screen.textAboveLogoQr.text"
              label="Текст над лого Оплатой QR кодом"
              type="text"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="3"
          >
            <uploadFiles
              v-model="screen.logoQrFile"
              label="Логотип для вида оплаты QR кодом"
              :btn_text="'Загрузить фотографию'"
              :limit="1"
              :single="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-text-field
              v-model="screen.logoQrData.width"
              label="Ширина изображения"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-text-field
              v-model="screen.logoQrData.height"
              label="Высота изображения"
              type="number"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col
            cols="12"
            class="cyan--text text--lighten-1"
          >
            Текст под лого Оплатой QR кодом
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.textBelowLogoQr.size"
              label="Размер шрифта"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.textBelowLogoQr.color"
              label="Цвет шрифта"
            />
          </v-col>
          <v-col
            cols="12"
            md="12"
          >
            <v-textarea
              v-model="screen.textBelowLogoQr.text"
              label="Текст под лого Оплатой QR кодом"
              type="text"
            />
          </v-col>
        </v-row>
        <!-- end Logo QR -->

        <!-- Logo staff -->
        <v-row>
          <v-col
            cols="12"
            class="deep-purple--text text--lighten-1"
          >
            Текст над лого Оплатой картой сотрудника
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.textAboveLogoStaff.size"
              label="Размер шрифта"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.textAboveLogoStaff.color"
              label="Цвет шрифта"
            />
          </v-col>
          <v-col
            cols="12"
            md="12"
          >
            <v-textarea
              v-model="screen.textAboveLogoStaff.text"
              label="Текст над лого Оплатой картой сотрудника"
              type="text"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="3"
          >
            <uploadFiles
              v-model="screen.logoStaffFile"
              label="Логотип для вида оплаты картой сотрудника"
              :btn_text="'Загрузить фотографию'"
              :limit="1"
              :single="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-text-field
              v-model="screen.logoStaffData.width"
              label="Ширина изображения"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-text-field
              v-model="screen.logoStaffData.height"
              label="Высота изображения"
              type="number"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col
            cols="12"
            class="cyan--text text--lighten-1"
          >
            Текст под лого Оплатой картой сотрудника
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.textBelowLogoStaff.size"
              label="Размер шрифта"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.textBelowLogoStaff.color"
              label="Цвет шрифта"
            />
          </v-col>
          <v-col
            cols="12"
            md="12"
          >
            <v-textarea
              v-model="screen.textBelowLogoStaff.text"
              label="Текст под лого Оплатой картой сотрудника"
              type="text"
            />
          </v-col>
        </v-row>
        <!-- end Logo stuff -->

        <!-- Logo scan -->
        <v-row>
          <v-col
            cols="12"
            class="deep-purple--text text--lighten-1"
          >
            Текст над лого Оплатой сканирование QR
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.textAboveLogoScan.size"
              label="Размер шрифта"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.textAboveLogoScan.color"
              label="Цвет шрифта"
            />
          </v-col>
          <v-col
            cols="12"
            md="12"
          >
            <v-textarea
              v-model="screen.textAboveLogoScan.text"
              label="Текст над лого Оплатой сканирование QR"
              type="text"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="3"
          >
            <uploadFiles
              v-model="screen.logoScanFile"
              label="Логотип для вида оплаты сканирование QR"
              :btn_text="'Загрузить фотографию'"
              :limit="1"
              :single="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-text-field
              v-model="screen.logoScanData.width"
              label="Ширина изображения"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-text-field
              v-model="screen.logoScanData.height"
              label="Высота изображения"
              type="number"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col
            cols="12"
            class="cyan--text text--lighten-1"
          >
            Текст под лого Оплатой сканирование QR
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.textBelowLogoScan.size"
              label="Размер шрифта"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.textBelowLogoScan.color"
              label="Цвет шрифта"
            />
          </v-col>
          <v-col
            cols="12"
            md="12"
          >
            <v-textarea
              v-model="screen.textBelowLogoScan.text"
              label="Текст под лого Оплатой сканирование QR"
              type="text"
            />
          </v-col>
        </v-row>
        <!-- end Logo scan -->

        <v-row>
          <v-col cols="12">
            <v-checkbox
              v-model="screen.showButton"
              label="Показывать кнопку Отмена на экране"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <strong>Кнопка отмены</strong>
          </v-col>
          <v-col
            cols="12"
          >
            <v-text-field
              v-model="screen.button1.radius"
              label="Размер радиуса"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.button1.text.size"
              label="Размер шрифта"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.button1.text.color"
              label="Цвет шрифта"
            />
          </v-col>
          <v-col
            cols="12"
            md="12"
          >
            <v-text-field
              v-model="screen.button1.background"
              label="Цвет фона"
            />
          </v-col>
        </v-row>
      </v-expansion-panel-content>
    </v-col>
  </v-row>
</template>
<script>

import { fifthScreen } from "@/views/loyalty/models/justpay-configuration-interface.model"

export default {
  name: 'SetupPaymentMethodScreen',
  model: {
    prop: "screen",
    event: "changeScreen",
  },
  props: {
    confType: {
      type: Number,
      default: 0
    },
    screen: {
      default: () => (fifthScreen)
    },
  },
  watch: {
    screen () {
      this.$emit('changeScreen', this.screen)
    }
  },
}
</script>

<style scoped>

</style>
